import { ApiResponse } from '@interfaces/api';
import { SavedPaymentCard } from '@interfaces/models/paymentMethod';
import Environment from '@config/index';
import { axios, getAxiosConfig } from '@config/axios';
import { Env } from '@interfaces/models/environment';

export default class PaymentCardService {
  static apiBaseUrl: Env['apiBaseUrl'] = Environment.apiBaseUrl;

  static async deletePaymentCard(id: SavedPaymentCard['id']): Promise<void> {
    const axiosConfig = getAxiosConfig();
    await axios.delete(`${this.apiBaseUrl}/payment-cards/${id}`, axiosConfig);
  }

  static async getPaymentCards(): Promise<SavedPaymentCard[]> {
    const axiosConfig = getAxiosConfig();
    const {
      data: { data },
    } = await axios.get<ApiResponse<SavedPaymentCard[]>>(`${this.apiBaseUrl}/payment-cards`, axiosConfig);
    return data;
  }
}
